export const listData = [
  {
    id: 1,
    text: "Top quality dental team",
  },

  {
    id: 2,
    text: "State of the art dental services",
  },

  {
    id: 3,
    text: "Discount on all dental treatment",
  },
];
